export default __webpack_public_path__ + "static/media/ceo-speaks-image.adebe0b2.png";